function capitalize(str) {
    let words = str.split(' ');
    for (let i = 0; i < words.length; i++) {
        words[i] = words[i][0].toUpperCase() + words[i].substring(1);
    }
    return words.join(' ');
}


const processPostSlug = (curSlug) => {

    if (!curSlug) {
      return curSlug;
    }
    if (curSlug.endsWith("-2")) {
      return curSlug.replace("-2", "");
    }
    return curSlug;
  }


  module.exports = { capitalize, processPostSlug }